module.exports = __webpack_public_path__ + "static/adjustable-base-2-reading-daba6d3e804de7cebf88438a34deb524.png";